import React, { useEffect, useState } from 'react';

import Portal from '@components/Portal';

import styles from './Toast.module.scss';

interface ToastProps {
  message: string | null;
  setMessage: (message: string | null) => void;
  duration?: number;
}

const NAVBAR_HEIGHT = 72;
const OFFSET = 24;

const Toast = ({ message, setMessage, duration = 3000 }: ToastProps) => {
  const [topPosition, setTopPosition] = useState('96px');
  useEffect(() => {
    let timerId: NodeJS.Timeout | undefined;
    if (message) {
      timerId = setTimeout(() => {
        setMessage(null);
      }, duration);
    }
    return () => {
      if (!!timerId) {
        clearTimeout(timerId);
      }
    };
  }, [message, setMessage, duration]);

  useEffect(() => {
    // It should not overlap with the navbar
    const handleScroll = () => {
      const scrollY = window.scrollY;
      if (scrollY >= NAVBAR_HEIGHT) {
        setTopPosition(`${OFFSET}px`);
      } else {
        const newPosition = OFFSET + (NAVBAR_HEIGHT - scrollY);
        setTopPosition(`${newPosition}px`);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  if (!!message) {
    return (
      <Portal>
        <div className={styles.container} style={{ top: topPosition }}>
          <div className={styles.messageWrapper}>
            <div>{message}</div>
          </div>
        </div>
      </Portal>
    );
  }

  return null;
};

export default Toast;
